import { WHATSAPP } from './contacto';

// Conversational flows for GUIA
// isResult: true → muestra ResultExtras debajo del mensaje
// navTo: ruta a la que navegar cuando el usuario hace click en el CTA principal
// skippable: true → el input acepta envío vacío ("Continuar sin decirlo")
// noEscape: true → no muestra el link "Tengo otra necesidad →"
// multiselect: true → chips toggleables, "Continuar →" al final


export const FLOWS = {

  // ── PASO 1: pregunta principal ────────────────────────────────────────────
  start: {
    id: 'start',
    message: '¿Qué necesitás resolver?',
    noEscape: true,
    options: [
      { label: 'Usar IA en mi negocio',                   next: 'ia_rol' },
      { label: 'Capacitar a mi equipo en IA',             next: 'taller_q1' },
      { label: 'Una web que aparezca en Google y en la IA', next: 'web_has_site' },
      { label: 'Ordenar cómo trabaja mi empresa',         next: 'sistema_rol' },
      { label: 'Otra cosa',                               next: 'freeform' },
    ],
  },

  // ── WEB ───────────────────────────────────────────────────────────────────

  web_has_site: {
    id: 'web_has_site',
    message: '¿Tu negocio ya tiene un sitio web?',
    options: [
      { label: 'Sí, ya tiene',  next: 'web_url_yes' },
      { label: 'Todavía no',   next: 'web_nombre' },
    ],
  },

  // Path A: ya tiene web → pedimos URL → feeling → resultado
  web_url_yes: {
    id: 'web_url_yes',
    message: '¿Cuál es la dirección del sitio?',
    input: true,
    skippable: true,
    placeholder: 'tunegocio.com.ar',
    dataKey: 'existingWebUrl',
    next: 'web_feeling_existing',
  },

  web_feeling_existing: {
    id: 'web_feeling_existing',
    message: '¿Qué querés que piense alguien cuando entra a tu sitio?',
    options: [
      { label: '«Este es exactamente lo que buscaba»',  next: 'web_result_existing' },
      { label: '«Quiero saber más de esto»',            next: 'web_result_existing' },
      { label: '«Me da confianza, quiero contactarlos»',      next: 'web_result_existing' },
      { label: '«Necesito esto ahora mismo»',           next: 'web_result_existing' },
    ],
    dataKey: 'feeling',
  },

  // Path B: no tiene web → nombre → qué hace → feeling → cómo llegan → visibilidad → resultado
  web_nombre: {
    id: 'web_nombre',
    message: '¿Cómo se llama tu negocio?',
    input: true,
    placeholder: 'Ej: Panadería Don Jorge',
    dataKey: 'businessName',
    next: 'web_rubro_q',
  },

  web_rubro_q: {
    id: 'web_rubro_q',
    message: '¿A qué se dedica tu negocio?',
    input: true,
    placeholder: 'Ej: pan artesanal en Alberdi',
    dataKey: 'businessInfo',
    next: 'web_feeling',
  },

  web_feeling: {
    id: 'web_feeling',
    message: '¿Qué querés que piense alguien cuando entra a tu sitio?',
    options: [
      { label: '«Este es exactamente lo que buscaba»',  next: 'web_q1' },
      { label: '«Quiero saber más de esto»',            next: 'web_q1' },
      { label: '«Me da confianza, quiero contactarlos»',      next: 'web_q1' },
      { label: '«Necesito esto ahora mismo»',           next: 'web_q1' },
    ],
    dataKey: 'feeling',
  },

  web_q1: {
    id: 'web_q1',
    message: '¿Cómo te encuentra la gente hoy?',
    multiselect: true,
    options: [
      { label: 'Redes sociales',             value: 'redes' },
      { label: 'Boca en boca',               value: 'bocaenboca' },
      { label: 'Nadie me encuentra todavía', value: 'nadie', exclusive: true },
    ],
    dataKey: 'howFound',
    next: 'web_q2',
  },

  web_q2: {
    id: 'web_q2',
    message: 'Si alguien te busca hoy en Google, ¿aparecés?',
    options: [
      { label: 'Sí, aparezco bien',      next: 'web_result' },
      { label: 'Sí, tengo Google Ads',   next: 'web_result' },
      { label: 'Probablemente no',       next: 'web_result' },
      { label: 'Nunca lo revisé',    next: 'web_result' },
    ],
    dataKey: 'searchability',
  },

  web_result: {
    id: 'web_result',
    servicio: 'Web',
    isResult: true,
    cierre: true,
    navTo: '/loading',
    navType: 'web',
    navDest: '/web-start',
    message: 'Tu negocio, visible también para la IA.\n\nUna web propia, pensada para que te encuentren en Google, en ChatGPT y donde busque la gente.',
    priceNote: 'Pago único de armado y mantenimiento opcional. La web es tuya desde el primer día.',
    bullets: [
      'Aparecés cuando buscan lo que hacés, en la IA y en Google',
      'Diseño propio, no una plantilla genérica',
      'La editás vos, sin depender de nadie',
    ],
    ctas: [
      { label: 'Quiero verlo →', action: 'navigate' },
      { label: 'Escribime →', href: `https://wa.me/${WHATSAPP}?text=Hola%20Antonela%2C%20quiero%20una%20web%20para%20mi%20negocio.%20%C2%BFC%C3%B3mo%20arrancamos%3F` },
    ],
  },

  web_result_existing: {
    id: 'web_result_existing',
    servicio: 'Web (ya tiene)',
    isResult: true,
    cierre: true,
    navTo: '/loading',
    navType: 'web',
    navDest: '/web-start',
    message: 'Tener una web no alcanza: tiene que servir.\n\nLa mayoría no está pensada para la era de la IA. GUIA la optimiza para que aparezcas cuando te busquen, en Google, en ChatGPT y donde sea que busquen.',
    priceNote: 'Pago único por la optimización. La web queda en tus manos.',
    bullets: [
      'Revisamos cómo está tu presencia hoy',
      'Quien busca lo que ofrecés, te encuentra',
      'Tu web queda clara y fácil de leer',
      'Panel propio para editarla cuando quieras',
    ],
    ctas: [
      { label: 'Quiero verlo →', action: 'navigate' },
      { label: 'Escribime →', href: `https://wa.me/${WHATSAPP}?text=Hola%20Antonela%2C%20tengo%20una%20web%20y%20quiero%20mejorarla.%20%C2%BFLa%20podemos%20revisar%3F` },
    ],
  },

  // ── FREEFORM ──────────────────────────────────────────────────────────────
  freeform: {
    id: 'freeform',
    message: '¿Qué necesitás? Describí tu situación con tus palabras.',
    input: true,
    placeholder: 'Escribí acá tu situación…',
    dataKey: 'freeformNeed',
    next: 'freeform_result',
    noEscape: true,
  },
  freeform_result: {
    id: 'freeform_result',
    servicio: 'Otra situación',
    isResult: true,
    cierre: true,
    message: 'Gracias por contarnos tu situación.\n\nConviene conversarlo con atención: la tecnología tiene que adaptarse a tu caso y no al revés.',
    ctas: [
      { label: 'Escribime →', href: `https://wa.me/${WHATSAPP}?text=Hola%20Antonela%2C%20tengo%20una%20necesidad%20particular%20que%20quiero%20contarte.%20%C2%BFCharlamos%3F` },
    ],
  },

  // ── IMPLEMENTAR IA ────────────────────────────────────────────────────────
  // Primero quién es y a qué se dedica; después qué le pesa. De lo general a lo
  // específico: sin contexto, "¿qué tarea?" no se puede contestar bien.
  ia_rol: {
    id: 'ia_rol',
    message: '¿Cuál es tu rol?',
    options: [
      { label: 'Soy dueño/a o socio/a',       next: 'ia_negocio' },
      { label: 'Lidero un equipo o un área',  next: 'ia_negocio' },
      { label: 'Trabajo por mi cuenta',       next: 'ia_negocio' },
      { label: 'Soy parte de un equipo',      next: 'ia_negocio' },
    ],
    dataKey: 'rol',
  },

  ia_negocio: {
    id: 'ia_negocio',
    message: '¿A qué se dedica el negocio?',
    input: true,
    placeholder: 'Ej: un estudio contable',
    dataKey: 'businessInfo',
    next: 'ia_q1',
  },

  ia_q1: {
    id: 'ia_q1',
    message: '¿Qué tarea te gustaría automatizar?',
    options: [
      { label: 'Contestar lo mismo por WhatsApp o mail', next: 'ia_q2' },
      { label: 'Cargar datos a mano',                    next: 'ia_q2' },
      { label: 'Armar informes o reportes',              next: 'ia_q2' },
      { label: 'Otra cosa',                              next: 'ia_q1_otra' },
    ],
    dataKey: 'iaTarea',
  },

  ia_q1_otra: {
    id: 'ia_q1_otra',
    message: 'Contanos cuál.',
    input: true,
    placeholder: 'Ej: pasar pedidos al sistema',
    dataKey: 'iaTarea',
    next: 'ia_q2',
  },

  // Si trabaja por su cuenta, el tamaño del equipo ya se sabe.
  ia_q2: {
    id: 'ia_q2',
    message: '¿Quiénes intervienen hoy en esa tarea?',
    skipIf: { dataKey: 'rol', equals: 'Trabajo por mi cuenta', to: 'ia_result' },
    options: [
      { label: 'Solo yo',                          next: 'ia_result' },
      { label: 'Yo y una o dos personas más',      next: 'ia_result' },
      { label: 'Un equipo completo',               next: 'ia_result' },
      { label: 'Varias áreas de la organización',  next: 'ia_result' },
    ],
    dataKey: 'equipo',
  },

  ia_result: {
    id: 'ia_result',
    servicio: 'Implementar IA',
    isResult: true,
    cierre: true,
    message: 'Eso se puede ordenar.\n\nLa IA sirve cuando se incorpora a un proceso que ya existe. Primero analizamos cómo trabajás hoy; qué automatizar se define después.',
    bullets: [
      'Empezamos por una sola tarea: la que más te pesa',
      'Lo que se construye queda funcionando con tu equipo',
    ],
    ctas: [
      { label: 'Escribime →', href: `https://wa.me/${WHATSAPP}?text=${encodeURIComponent('Hola Antonela, quiero implementar IA en mi negocio. ¿Charlamos?')}` },
    ],
  },

  // ── CAPACITAR AL EQUIPO ───────────────────────────────────────────────────
  taller_q1: {
    id: 'taller_q1',
    message: '¿A quién querés capacitar?',
    options: [
      { label: 'A mí',                 next: 'taller_result' },
      { label: 'A un equipo chico',    next: 'taller_result' },
      { label: 'A toda la empresa',    next: 'taller_result' },
    ],
    dataKey: 'alcanceTaller',
  },

  taller_result: {
    id: 'taller_result',
    servicio: 'Capacitación en IA',
    isResult: true,
    cierre: true,
    academia: true,
    message: 'Se aprende haciendo.\n\nCuatro semanas: en la primera se define el problema real, y en la última cada persona se va con un asistente propio funcionando.',
    bullets: [
      'Grupos chicos, con tu caso sobre la mesa',
      'Hay un encuentro gratuito de 45 minutos para ver si te conviene',
    ],
    ctas: [
      { label: 'Escribime →', href: `https://wa.me/${WHATSAPP}?text=${encodeURIComponent('Hola Antonela, quiero capacitar en IA. ¿Charlamos?')}` },
    ],
  },

  // ── ORDENAR LA OPERACIÓN ──────────────────────────────────────────────────
  sistema_rol: {
    id: 'sistema_rol',
    message: '¿Cuál es tu rol?',
    options: [
      { label: 'Soy dueño/a o socio/a',       next: 'sistema_negocio' },
      { label: 'Lidero un equipo o un área',  next: 'sistema_negocio' },
      { label: 'Trabajo por mi cuenta',       next: 'sistema_negocio' },
      { label: 'Soy parte de un equipo',      next: 'sistema_negocio' },
    ],
    dataKey: 'rol',
  },

  sistema_negocio: {
    id: 'sistema_negocio',
    message: '¿A qué se dedica el negocio?',
    input: true,
    placeholder: 'Ej: una distribuidora de bebidas',
    dataKey: 'businessInfo',
    next: 'sistema_q1',
  },

  sistema_q1: {
    id: 'sistema_q1',
    message: '¿Qué parte de la operación se te desordena?',
    options: [
      { label: 'Las ventas o la caja',        next: 'sistema_q2' },
      { label: 'Los pedidos o el stock',      next: 'sistema_q2' },
      { label: 'Quién hace qué y cuándo',     next: 'sistema_q2' },
      { label: 'Otra cosa',                   next: 'sistema_q1_otra' },
    ],
    dataKey: 'operacion',
  },

  sistema_q1_otra: {
    id: 'sistema_q1_otra',
    message: 'Contanos cuál.',
    input: true,
    placeholder: 'Ej: las ventas de cada sucursal',
    dataKey: 'operacion',
    next: 'sistema_q2',
  },

  sistema_q2: {
    id: 'sistema_q2',
    message: '¿Cómo llevás hoy esa parte?',
    options: [
      { label: 'En planillas o a mano',            next: 'sistema_result' },
      { label: 'Tengo un sistema y no me sirve',   next: 'sistema_result' },
      { label: 'No lo anoto en ningún lado',        next: 'sistema_result' },
    ],
    dataKey: 'comoLoLleva',
  },

  sistema_result: {
    id: 'sistema_result',
    servicio: 'Ordenar la operación',
    isResult: true,
    cierre: true,
    message: 'Muchas veces el sistema que falta ya existe, escondido en las planillas que usás.\n\nPrimero se analiza el dato que tu negocio genera hoy. De ahí sale la pantalla que te ordena el día.',
    bullets: [
      'Se arma sobre las planillas que ya usás',
      'Primero una pantalla que sirva; el resto viene después',
      'Queda en manos de tu equipo',
    ],
    ctas: [
      { label: 'Escribime →', href: `https://wa.me/${WHATSAPP}?text=${encodeURIComponent('Hola Antonela, necesito ordenar cómo trabaja mi empresa. ¿Charlamos?')}` },
    ],
  },
};
